import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0a2f122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bolder"} }, "Chọn khoảng thời gian thống kê: ", -1))
const _hoisted_4 = {
  class: "col-12 p-col-12 p-md-12",
  style: {"height":"100%"}
}
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "col-12 p-col-6 p-md-6" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "col-12 p-col-6 p-md-6"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, null, -1))
const _hoisted_12 = { class: "col-12 p-col-12 p-md-12" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, "Biểu đồ thống kê số lượt khám thành công trong 2 năm", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thống kê doanh thu" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Calendar, {
            id: "date",
            modelValue: _ctx.date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
            selectionMode: "range",
            dateFormat: "dd/mm/yy",
            showButtonBar: true,
            showIcon: true,
            manualInput: false,
            monthNavigator: true,
            yearNavigator: true,
            yearRange: "2000:2100",
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCalendar())),
            onClearClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearCalendar()))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Panel, {
                    header: "Biểu đồ so sánh số lượng gởi trong tháng",
                    style: {"height":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_component_apexchart, {
                          type: "pie",
                          options: _ctx.optionsPie,
                          series: _ctx.seriesPie
                        }, null, 8, ["options", "series"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.selectDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_Panel, {
                        header: "Biểu đồ so sánh số lượng gởi trong 1 khoảng thời gian",
                        style: {"height":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createVNode(_component_apexchart, {
                              type: "pie",
                              options: _ctx.optionsPieSelect,
                              series: _ctx.seriesPieSelect
                            }, null, 8, ["options", "series"])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_apexchart, {
                  type: "bar",
                  options: _ctx.options,
                  series: _ctx.series
                }, null, 8, ["options", "series"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}